<div class="output-item" [@containerAnimation]="animationState"
(@containerAnimation.done)="onContainerAnimationComplete($event)">
    <h6>{{outputItem?.header}}</h6>
    <p>{{outputItem?.description}}</p>
    <ul [@itemsAnimation]="{ value: itemsAnimationState, params: { staggerDelay: '100ms' } }"
    (@itemsAnimation.done)="onItemsAnimationComplete($event)">
        <li *ngFor="let item of visibleItems">{{item}}</li>
    </ul>
</div>


